export default "__VITE_ASSET__94cd1eff__"